import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { OriginalMenu } from 'types/menu';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from '../../../constants/registrationStep';

/**
 * メニューの詳細画面の状態
 */
interface MenuDetailState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中のメニュー */
  selected: OriginalMenu | null;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * メニュー詳細画面の初期状態
 */
const initialState: MenuDetailState = {
  loading: false,
  selected: null,
  isOpenModalDelete: false,
  step: REGISTRATION_STEP.INPUT,
};

/**
 * メニュー詳細画面の slice(reducer + action)
 */
export const menuDetailSlice = createSlice({
  name: 'menuDetailMenuCategory',
  initialState,
  reducers: {
    initialize: () => initialState,
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    modalOpened: (
      state,
      { payload }: PayloadAction<MenuDetailState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateStep: (
      state,
      { payload }: PayloadAction<MenuDetailState['step']>,
    ) => ({
      ...state,
      step: payload,
    }),
  },
});

/**
 * メニュー詳細画面の action
 */
export const menuDetailActions = menuDetailSlice.actions;

/**
 * メニュー詳細画面の selectors
 */
export const menuDetailSelectors = {
  selectedMenu: (state: RootState) => state.menuCategory.menuDetail.selected,
  isOpenModalDelete: (state: RootState) =>
    state.menuCategory.menuDetail.isOpenModalDelete,
  currentModalStep: (state: RootState) => state.menuCategory.menuDetail.step,
} as const;
